import React, { memo } from 'react';
import { useDashboardPopup } from '../contexts/DashboardPopupContext';
import DashboardPopup from './DashboardPopup';

/**
 * DashboardPopupManager
 * 모든 열린 팝업을 관리하고 렌더링하는 컴포넌트
 */
const DashboardPopupManager = memo(() => {
  const {
    popups,
    activePopupId,
    closePopup,
    focusPopup,
    toggleMinimize,
    toggleMaximize,
    updatePopupPosition,
    updatePopupSize,
    setPopupLoading,
    setPopupError,
    setPopupLoadComplete
  } = useDashboardPopup();
  
  // 팝업이 없으면 null 반환
  if (popups.length === 0) {
    return null;
  }
  
  return (
    <>
      {popups.map(popup => (
        <DashboardPopup
          key={popup.id}
          popup={popup}
          isActive={popup.id === activePopupId}
          onClose={() => closePopup(popup.id)}
          onFocus={() => focusPopup(popup.id)}
          onMinimize={() => toggleMinimize(popup.id)}
          onMaximize={() => toggleMaximize(popup.id)}
          onPositionChange={updatePopupPosition}
          onSizeChange={updatePopupSize}
          onLoadComplete={(popupId) => setPopupLoadComplete(popupId)}
          onError={(popupId, error) => setPopupError(popupId, error)}
        />
      ))}
    </>
  );
});

DashboardPopupManager.displayName = 'DashboardPopupManager';

export default DashboardPopupManager;